import React, { useState } from 'react';
import CustomSelect from "../../../components/common/select/Select";
import { valueConverter_2 } from '../../../util-functions/util-funtions';


export default function MtftsMskus(
    {
        sku_item,
        sku_index,
        item,
        awsBaseline,
        data,
        index,
        enumData,
        baselineChange,
        formType
    }) {

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <div className="sku_main">
                <div className="sku_inner_body">
                    <div
                        className="sku_content_div"
                        style={{ width: "112.4vw" }}
                    >
                        <label className="sku_keys">
                            Master Sku Name
                        </label>
                        <label className="sku_val">
                            {sku_item.Description} {item.expanded}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label className="sku_keys">
                            Master Sku Code
                        </label>
                        <label className="sku_val">
                            {sku_item.Code}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            {formType === 'ic' ? 'Gp/Litre' : 'Gp/Ton'}
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {valueConverter_2(sku_item.GpTon)}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label className="sku_keys">
                            Aws Baseline
                        </label>
                        <label className="sku_baseline">
                            <input
                                type="number"
                                className="other_detail_input"
                                onChange={(e) =>
                                    baselineChange(e, sku_index, index)
                                }
                                name="awsBaseline"
                                value={
                                    awsBaseline !== "isEmpty"
                                        ? awsBaseline
                                        : sku_item.Baseline
                                }
                            />
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            Total Cost
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {!sku_item.TotalCost
                                ? 0
                                : valueConverter_2(sku_item.TotalCost)}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            Inc Vol
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {!sku_item.IncVolume
                                ? 0
                                : valueConverter_2(sku_item.IncVolume)}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            Act Duration
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {data.ActivityDuration}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            Pricing
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {sku_item.Pricing.toFixed(10)}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            Grammage
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {sku_item.Grammage.toFixed(10)}
                        </label>
                    </div>
                    <div className="sku_content_div">
                        <label
                            className="sku_keys"
                            style={{ textAlign: "center" }}
                        >
                            ROI(%)
                        </label>
                        <label
                            className="sku_val"
                            style={{ textAlign: "center" }}
                        >
                            {!sku_item.Roi ? 0 : valueConverter_2(sku_item.Roi)}
                        </label>
                    </div>
                </div>

                {isExpanded && (
                    <div className="sku_expand_body content">
                        <div className="sku_expand_div">
                            <div className="expanded_content">
                                <label className="sku_keys">
                                    Incremental Aws
                                </label>
                                <label className="sku_val">
                                    {valueConverter_2(sku_item.ActivatedAws)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label className="sku_keys">
                                    Total Inc Act Vol
                                </label>
                                <label className="sku_val">
                                    {valueConverter_2(sku_item.TotalActivatedVolume)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label
                                    className="sku_keys"
                                    style={{ textAlign: "left" }}
                                >
                                    Post Aws
                                </label>
                                <label className="sku_val">
                                    {valueConverter_2(sku_item.PostAws)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label
                                    className="sku_keys"
                                    style={{ paddingLeft: "1.7vw" }}
                                >
                                    DNDS Vol
                                </label>
                                <label
                                    className="sku_val"
                                    style={{ paddingLeft: "1.7vw" }}
                                >
                                    {!sku_item.DndsVolume
                                        ? 0
                                        : valueConverter_2(sku_item.DndsVolume)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label className="sku_keys">
                                    Total Vol
                                </label>
                                <label className="sku_val">
                                    {!sku_item.TotalVolume
                                        ? 0
                                        : valueConverter_2(sku_item.TotalVolume)}
                                </label>
                            </div>

                            <div className="expanded_content">
                                <label className="sku_keys">
                                    Org Norm
                                </label>
                                <label className="sku_val">
                                    {valueConverter_2(sku_item.OrgNorm)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label
                                    className="sku_keys"
                                    style={{ textAlign: "left" }}
                                >
                                    Norm
                                </label>
                                <label className="sku_val">
                                    {valueConverter_2(sku_item.Norm)}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label
                                    className="sku_keys"
                                    style={{ paddingLeft: "1vw" }}
                                >
                                    Norm Delta
                                </label>
                                <label
                                    className="sku_val"
                                    style={{ paddingLeft: "1vw" }}
                                >
                                    {sku_item.Percentage}
                                </label>
                            </div>
                            <div className="expanded_content">
                                <label className="sku_keys">
                                    Norm Type
                                </label>
                                <label className="sku_baseline">
                                    <CustomSelect.MySelect
                                        isDisabled={true}
                                        placeholder="Norm Type"
                                        options={
                                            enumData
                                                ? enumData
                                                    .filter((filter_item) => {
                                                        return (
                                                            filter_item.Type ===
                                                            "DISCOUNT_TYPE"
                                                        );
                                                    }).filter(for_freesku => {
                                                        return for_freesku.guid !== 'b2e41bb3-a11d-48f1-b041-b9c04c956e7a'
                                                    })
                                                    .map((map_item) => {
                                                        return {
                                                            value: map_item.guid,
                                                            label: map_item.Label,
                                                        };
                                                    })
                                                : []
                                        }
                                        value={
                                            enumData
                                                ? enumData
                                                    .filter((filter_item) => {
                                                        return  filter_item.guid === sku_item.NormType
                                                    })
                                                    .map((map_item) => {
                                                        return {
                                                            value: map_item.guid,
                                                            label: map_item.Label,
                                                        };
                                                    })
                                                : void 0
                                        }
                                        onChange={() => { }}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                )}

                <div className="sku_right_arrow collapsible">
                    <img
                        src={
                            isExpanded
                                ? require("../../gt/images/arrowUp.svg")
                                : require("../../gt/images/arrowDown.svg")
                        }
                        onClick={() => setIsExpanded(!isExpanded)}
                        alt=''
                    />
                </div>
            </div>

        </>
    );
}
